import script from "./TheAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./TheAccordion.vue?vue&type=script&setup=true&lang=js"

import "./TheAccordion.vue?vue&type=style&index=0&id=6f168d0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f168d0d"]])

export default __exports__